import { HelperBotType, HelperBotTypeLabels, RankType } from "./enum/enum";

export const HELPER_BOT_BULLET_PRICE = 200;

export const HelperBots = [
  {
    id: 0,
    imageUrl:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/helperbot-crimes.png",
    name: HelperBotTypeLabels[HelperBotType.CrimeBot],
    description:
      "A stealthy robot with cloaking tech, swift movements, and adaptive weapons, executing street crimes like theft and vandalism with precision, evading authorities",
    rank: "Low" as RankType,
    timeRemaining: "15 minutes",
    credits: 1,
    isStarted: false,
    min: 10,
    max: 5000,
    helperBotCount: [
      10, 20, 50, 100, 150, 200, 300, 500, 1000, 2000, 3000, 4000, 5000,
    ],
    attemptDuration: 12, // 12 minutes
    cashReward: true,
  },
  {
    id: 1,
    imageUrl:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/helperbot-cars.png",
    name: HelperBotTypeLabels[HelperBotType.GrandTheftAutoBot],
    description:
      "A sleek robot with advanced hacking tools, silent hydraulics, and infrared sensors, effortlessly bypassing security systems to steal cars with precision and speed.",
    rank: "Medium" as RankType,
    credits: 4,
    isStarted: false,
    min: 36, // This is rounded value, original min value from contract is 45
    max: 5000, // This is rounded value, original max value from contract is 350
    helperBotCount: [
      40, 80, 160, 320, 480, 640, 800, 1200, 1600, 2000, 2400, 3200, 4000, 5000,
    ],
    attemptDuration: 30, // 30 minutes
    cashReward: true,
  },

  {
    id: 3,
    imageUrl:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/helperbot-booze.png",
    name: HelperBotTypeLabels[HelperBotType.BoozeSmugglingBot],
    description:
      "A robot with hidden compartments, adaptive routes, and encrypted communications, efficiently smuggling booze past authorities, maximizing profits through stealth and strategic black-market deals.",
    rank: "High" as RankType,
    credits: 7,
    isStarted: false,
    min: 210, // This is rounded value, original min value from contract is 200
    max: 4998, // This is rounded value, original max value from contract is 1500
    helperBotCount: [
      210, 420, 840, 1260, 1680, 2100, 2520, 2940, 3360, 3780, 4200, 4998,
    ],
    attemptDuration: 90, // 90 minutes
    cashReward: true,
  },
  {
    id: 4,
    imageUrl:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/helperbot-narcs.png",
    name: HelperBotTypeLabels[HelperBotType.NarcoticsSmugglingBot],
    description:
      "A robot with hidden compartments, adaptive routes, and encrypted communications, efficiently smuggling narcotics past authorities, maximizing profits through stealth and strategic black-market deals.",
    rank: "High" as RankType,
    credits: 10,
    isStarted: false,
    min: 350,
    max: 5000,
    helperBotCount: [350, 400, 450, 500, 750, 1000, 2000, 3000, 4000, 5000],
    attemptDuration: 140, // 140 minutes
    cashReward: true,
  },

  {
    id: 2,
    imageUrl:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/helperbot-killskill.png",
    name: HelperBotTypeLabels[HelperBotType.ShootingPracticeBot],
    description:
      "Introducing TargetTrainer, a robot diligently honing its aiming skills by shooting bottles in its backyard, utilizing advanced algorithms to improve accuracy and reaction time efficiently.",
    rank: "Medium" as RankType,
    credits: 8,
    isStarted: false,
    min: 504, // This is rounded value, original min value from contract is 500
    max: 4992,
    helperBotCount: [504, 960, 1200, 2400, 3600, 5000],
    attemptDuration: 35, // 35 minutes
    cashReward: false,
  },

  {
    id: 5,
    imageUrl:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/helperbot-bullets.png",
    name: HelperBotTypeLabels[HelperBotType.BulletDealerBot],
    description:
      "An automatic bot swiftly compares prices, checks legality, and assists users in purchasing bullets efficiently, ensuring compliance with local regulations and preferences.",
    rank: "Medium" as RankType,
    credits: 12,
    isStarted: false,
    min: 60, // This is rounded value, original min value from contract is 500
    max: 4992,
    helperBotCount: [60, 240, 480, 960, 1200, 2400, 3600, 4992],
    attemptDuration: 20, // 20 minutes
    cashReward: false,
    bulletReward: true,
    buyAmount: 3000,
    priceAvg: 200
  },

  {
    id: 6,
    imageUrl:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/helper_racing.png",
    name: HelperBotTypeLabels[HelperBotType.RaceXPBot],
    description:
      "An automatic bot that assists users in earning race XP efficiently, ensuring compliance with local regulations and preferences.",
    rank: "Medium" as RankType,
    credits: 5,
    isStarted: false,
    min: 10, // This is rounded value, original min value from contract is 500
    max: 100,
    helperBotCount: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
    attemptDuration: 180, // 180 minutes
    cashReward: false
  },

  {
    id: 7,
    imageUrl:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/helper_bustout.png",
    name: HelperBotTypeLabels[HelperBotType.BustOutXpBot],
    description:
      "An automatic bot that assists users in earning bust out XP efficiently, ensuring compliance with local regulations and preferences.",
    rank: "Medium" as RankType,
    credits: 2,
    isStarted: false,
    min: 4,
    max: 200,
    helperBotCount: [20, 40, 60, 80, 100, 120, 140, 160, 180, 200],
    attemptDuration: 8, // 8 minutes
    cashReward: false
  },
];
